"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clothesColors = exports.skinTones = exports.hairColors = exports.processHairAdj = exports.hairs = exports.heads = exports.bodies = void 0;
var colorUtil_1 = require("@lib/colorUtil");
var imports_1 = require("@lib/imports");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
exports.bodies = [
    {
        idx: 0,
        frames: sprites_sidecar_1.sprites.voyBody1,
        hx: 0,
        hy: 0,
    },
    {
        idx: 1,
        frames: sprites_sidecar_1.sprites.voyBody2,
        hx: 0,
        hy: 0,
    },
    {
        idx: 2,
        frames: sprites_sidecar_1.sprites.voyBody3,
        hx: 0,
        hy: 0,
    },
    {
        idx: 3,
        frames: sprites_sidecar_1.sprites.voyBody4,
        hx: 0,
        hy: 0,
    },
];
exports.heads = [
    {
        idx: 0,
        frames: sprites_sidecar_1.sprites.voyHead1,
        ox: 0,
        oy: 0,
    },
    {
        idx: 1,
        frames: sprites_sidecar_1.sprites.voyHead2,
        ox: 0,
        oy: 0,
    },
];
exports.hairs = [
    {
        idx: 0,
        frames: sprites_sidecar_1.sprites.voyHairBowl,
        adj: [],
        // ox: 1,
        // oy: 0,
    },
    {
        idx: 1,
        frames: sprites_sidecar_1.sprites.voyHairBuzz,
        adj: [],
        // ox: 2,
        // oy: 0,
    },
    {
        idx: 2,
        frames: sprites_sidecar_1.sprites.voyHairPigtails,
        adj: [],
        // ox: -1,
        // oy: 0,
    },
    {
        idx: 3,
        frames: sprites_sidecar_1.sprites.voyHairOld,
        adj: [],
        // ox: 0,
        // oy: 3,
    },
    {
        idx: 4,
        frames: sprites_sidecar_1.sprites.voyHairSpikes,
        adj: [],
        // ox: 3,
        // oy: -2,
    },
    {
        idx: 5,
        frames: [],
        adj: [],
        // ox: 0,
        // oy: 0,
    },
];
function processHairAdj() {
    imports_1.l.forEach(exports.heads, function (c) {
        imports_1.l.forEach(exports.hairs, function (d) {
            d.adj.push({
                ox: 0,
                oy: 0,
                sx: 1,
                sy: 1,
            });
        });
    });
}
exports.processHairAdj = processHairAdj;
processHairAdj();
// see: https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/a60d4c7d-23c6-4e9d-a143-cc2d471feb33/dbfxlq0-f221882e-e548-4023-9aea-b414a2a5d5f2.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2E2MGQ0YzdkLTIzYzYtNGU5ZC1hMTQzLWNjMmQ0NzFmZWIzM1wvZGJmeGxxMC1mMjIxODgyZS1lNTQ4LTQwMjMtOWFlYS1iNDE0YTJhNWQ1ZjIucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.FIpwgMEDeYbjp-r_gM-CVi7zqs7F-pjIblVq2y2bfe8
exports.hairColors = [
    colorUtil_1.hex('#C2B09F'),
    colorUtil_1.hex('#869D48'),
    colorUtil_1.hex('#CF9CC7'),
    colorUtil_1.hex('#F68045'),
    colorUtil_1.hex('#FDFBD1'),
    colorUtil_1.hex('#7CBA90'),
    colorUtil_1.hex('#E59BC3'),
    colorUtil_1.hex('#FF9E59'),
    colorUtil_1.hex('#FAD472'),
    colorUtil_1.hex('#A0B6B6'),
    colorUtil_1.hex('#FFBB99'),
    colorUtil_1.hex('#E0A56B'),
    colorUtil_1.hex('#C29242'),
    colorUtil_1.hex('#7E7B97'),
    colorUtil_1.hex('#FF6159'),
    colorUtil_1.hex('#B27D60'),
    colorUtil_1.hex('#EDCD6B'),
    colorUtil_1.hex('#AEB9FF'),
    colorUtil_1.hex('#9E3126'),
    colorUtil_1.hex('#BA9685'),
    colorUtil_1.hex('#D2BA5B'),
    colorUtil_1.hex('#C1BFD7'),
    colorUtil_1.hex('#ED6748'),
    colorUtil_1.hex('#806C75'),
];
// see: https://dch81km8r5tow.cloudfront.net/wp-content/uploads/2016/05/Dass_Angelica_Humanae_-Collage02.jpg
exports.skinTones = [
    colorUtil_1.hex('#B97F67'),
    colorUtil_1.hex('#E9BAA2'),
    colorUtil_1.hex('#CA8E74'),
    colorUtil_1.hex('#E7BFA5'),
    colorUtil_1.hex('#A57461'),
    colorUtil_1.hex('#F8D5C2'),
    colorUtil_1.hex('#D19B7E'),
    colorUtil_1.hex('#F7E4D6'),
    colorUtil_1.hex('#F0D4C1'),
    colorUtil_1.hex('#DBAD92'),
    colorUtil_1.hex('#E9C6B3'),
    colorUtil_1.hex('#E9C9B7'),
    colorUtil_1.hex('#CD9A7D'),
    colorUtil_1.hex('#DCAB94'),
    colorUtil_1.hex('#927571'),
    colorUtil_1.hex('#E5AF8C'),
    colorUtil_1.hex('#F0C7BF'),
    colorUtil_1.hex('#F0B996'),
    colorUtil_1.hex('#DDAA8D'),
    colorUtil_1.hex('#EDD3C8'),
    colorUtil_1.hex('#EDCDBD'),
    colorUtil_1.hex('#C28665'),
    colorUtil_1.hex('#F5DBCA'),
    colorUtil_1.hex('#F5D3B9'),
    colorUtil_1.hex('#E8C7B4'),
    colorUtil_1.hex('#F2D9CB'),
    colorUtil_1.hex('#DBA584'),
    colorUtil_1.hex('#EFDCD5'),
    colorUtil_1.hex('#F3D7C9'),
    colorUtil_1.hex('#CB9177'),
];
// see: https://lospec.com/palette-list/paper-pixels
exports.clothesColors = [
    colorUtil_1.hex('#D6C7A3'),
    colorUtil_1.hex('#ADA387'),
    colorUtil_1.hex('#CC9970'),
    colorUtil_1.hex('#A97E5C'),
    colorUtil_1.hex('#937B6A'),
    colorUtil_1.hex('#A0A0A0'),
    colorUtil_1.hex('#838383'),
    colorUtil_1.hex('#839CA9'),
    colorUtil_1.hex('#6D838E'),
    colorUtil_1.hex('#C87E7E'),
    colorUtil_1.hex('#A05E5E'),
    colorUtil_1.hex('#B089AB'),
    colorUtil_1.hex('#8E6D89'),
    colorUtil_1.hex('#B9AB73'),
    colorUtil_1.hex('#978C63'),
    colorUtil_1.hex('#87A985'),
    colorUtil_1.hex('#6F8B6E'),
];
